/**
 * Ambiente a cui punta l'admin. Serve a un solo scopo: far capire a colpo
 * d'occhio se si sta agendo su dati locali, di UAT o di produzione, prima di
 * approvare un utente o cambiare un tool.
 *
 * Si ricava dall'URL dell'API; VITE_ADMIN_ENV_LABEL lo sovrascrive quando il
 * nome host non basta.
 */
export type AdminEnvironmentKind = 'local' | 'uat' | 'production';

export interface AdminEnvironment {
    kind: AdminEnvironmentKind;
    label: string;
}

const LABELS: Record<AdminEnvironmentKind, string> = {
    local: 'Locale',
    uat: 'UAT',
    production: 'Produzione',
};

const detectKind = (): AdminEnvironmentKind => {
    const override = (import.meta.env.VITE_ADMIN_ENV_LABEL ?? '').trim().toLowerCase();
    if (override === 'local' || override === 'locale') return 'local';
    if (override === 'uat' || override === 'test') return 'uat';
    if (override === 'production' || override === 'prod' || override === 'produzione') return 'production';

    const apiUrl = (import.meta.env.VITE_API_BASE_URL ?? '').toLowerCase();
    const host = apiUrl || window.location.hostname.toLowerCase();
    if (!host || /localhost|127\.0\.0\.1|\[::1\]/.test(host)) return 'local';
    if (/uat|test|staging|dev/.test(host)) return 'uat';
    return 'production';
};

const kind = detectKind();

export const adminEnvironment: AdminEnvironment = { kind, label: LABELS[kind] };
